import axiosInstance from '../axiosInterceptor/axiosInstance'

// Backend (BUS-2798 Social slice): DELETE /api/v1/orgs/{orgId}/social/accounts. orgId is passed
// in by the caller (single source of truth); a federation unlinks a single competition by
// passing competitionId (omit for org level).
const postUnlinkSocials = ({ orgId, competitionId } = {}) => {
  const url = competitionId
    ? `v1/orgs/${orgId}/social/accounts?competitionId=${competitionId}`
    : `v1/orgs/${orgId}/social/accounts`
  return axiosInstance.delete(url)
}

export default postUnlinkSocials
